/**
 * The proposals page's view toggle values, extracted into a leaf module so
 * the route's `validateSearch` (which stays in the eager route-config
 * chunk) doesn't drag `lib/proposal.ts` — and with it zod — into the
 * initial bundle.
 */

/** A view value for the proposals page — the toggle between table and kanban. */
export type ProposalView = 'list' | 'board'
export const PROPOSAL_VIEWS: ProposalView[] = ['list', 'board']
